import React from "react";
import { Link } from "react-router-dom";
import { siteInfo } from "../data/mockData";
import { Phone, ArrowRight } from "lucide-react";
import { HeroSection } from "../components/home/HeroSection";
import { FeaturesGrid } from "../components/home/FeaturesGrid";
import { CourseHighlightsSection } from "../components/home/CourseHighlightsSection";
import { TestimonialsCarousel } from "../components/home/TestimonialsCarousel";
import { CallToAction } from "../components/home/CallToAction";

const Home = () => (
  <div className="overflow-hidden">
    <HeroSection />
    <FeaturesGrid />
    <CourseHighlightsSection />
    <TestimonialsCarousel />
    <CallToAction />

    {/* Contact Bar */}
    <section className="py-16 bg-[#f8f7f4]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B2A4A] mb-4">
          Ready to Visit?
        </h2>
        <p className="text-gray-500 mb-8 max-w-xl mx-auto">
          Contact us today to book your tee time, plan your event, or make a
          reservation at the Pub & Grill.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href={`tel:${siteInfo.phone}`}
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#1B2A4A] text-white font-semibold rounded-md hover:bg-[#2a3d62] transition-all duration-300 hover:shadow-lg"
          >
            <Phone size={18} />
            Call {siteInfo.phone}
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 border-2 border-[#1B2A4A] text-[#1B2A4A] font-semibold rounded-md hover:bg-[#1B2A4A] hover:text-white transition-all duration-300"
          >
            Contact Us
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default Home;
